import logo from '../img/logo2.png'

function Header() {
    return (
        <header className="header">
            <div className="row1">
                <h1>Професійний стандарт<br/> “Керівник (директор) закладу дошкільної освіти”</h1>
                <img src={logo} alt=""/>
            </div>
            <div className="row2">
                <p>Онлайн-застосунок створений на допомогу керівникам закладів дошкільної освіти з метою планування
                    професійного розвитку, комплексного оцінювання професійних компетентностей під час процедур
                    атестації та сертифікації. Інструмент розроблений на основі професійного стандарту за професіями
                    “Керівник (директор) закладу дошкільної освіти”.</p>
            </div>
        </header>
    )
}

export {Header}



